import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
}))

export default function SimpleResults({
  virtualMachines,
  allVmSuccess,
  successfulVmDeletions,
  vmDeletionResults,
}) {
  const classes = useStyles()
  return (
    <>
      <Text variant="subtitle2">
        <div className={clsx(classes.circleIcon, classes.greenCircle)}>
          <FontAwesomeIcon className={allVmSuccess ? classes.greenIcon : classes.redIcon} size="md">
            {allVmSuccess ? 'check' : 'xmark'}
          </FontAwesomeIcon>
        </div>
        {allVmSuccess
          ? `${virtualMachines?.length} ${
              virtualMachines?.length === 1 ? 'resource' : 'resources'
            } deleted`
          : 'Some resources weren’t deleted due to an error'}
      </Text>
      <div className={classes.simpleResultsTable}>
        <Text variant="body2">Virtual Machines:</Text>
        <Text variant="caption1">
          {successfulVmDeletions?.length} of {vmDeletionResults?.length} deleted
        </Text>
      </div>
    </>
  )
}
